"use client";

import React from "react";
import {Container, Paper, Typography} from "@mui/material";
import ProductGroup, {ProductGroupLevel} from "@/types/product-group";
import FaIcon from "@/components/utilities/fa-icon";
import CarAndCompanySlider from "@/app/(pages)/(general)/(home)/components/car-and-company-slider";


export default function CarAndCompanySection({
                                                 car,
                                                 productGroups = []
}: {
    productGroups?: ProductGroup[];
    car?: boolean;
}) {


    return (
        <Container sx = {{py: 6}} maxWidth = "lg" >
            <Paper elevation = {0} sx = {{py: 0, background: "transparent"}} >
                {car ? (
                    <CarAndCompanySlider
                        productGroups = {productGroups}
                        countInDesktop = {9}
                        targetLevel = {ProductGroupLevel.Car}
                        selectedCategoriesSection = "Car"
                        car = {true}
                    />
                ) : (
                    <>
                        <Typography
                            fontSize = {22}
                            fontWeight = {500}
                            gap = {1}
                            color="primary.main"
                            textAlign="center"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <FaIcon fontSize = {26} color = 'primary.main' faIcon = "fa-fire" />
                            برندهای محبوب
                        </Typography >

                        <CarAndCompanySlider
                            productGroups = {productGroups}
                            countInDesktop = {50}
                            noName
                            targetLevel = {ProductGroupLevel.Company}
                            selectedCategoriesSection = "Company"
                            car = {false}
                        />
                    </>
                )}
            </Paper >
        </Container >
    );
}
